import React from 'react';
import { MapPin, ExternalLink } from 'lucide-react';
import { Badge } from '../common/Badge';

export const MapResultCard: React.FC<{ result: any }> = ({ result }) => {
  const mapData = result.maps;
  if (!mapData) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col h-full p-5">
       <div className="flex items-start justify-between mb-4">
         <div className="p-2 bg-indigo-50 rounded-lg">
           <MapPin className="w-6 h-6 text-[#2f5c96]" />
         </div>
         <Badge color="blue">Google Maps</Badge>
       </div>
       <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">{mapData.title}</h3>
       <p className="text-sm text-gray-500 mb-4 line-clamp-3">{mapData.placeAnswerSources?.reviewSnippets?.[0]?.text || "View on map for more details."}</p>
       
       <div className="mt-auto">
         <a href={mapData.uri} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-4 py-2 bg-[#2f5c96] text-white rounded-lg font-medium hover:bg-[#c19cca] transition-colors">
           View on Maps <ExternalLink className="w-4 h-4 ml-2" />
         </a>
       </div>
    </div>
  );
};